import { jsx as _jsx } from "react/jsx-runtime";
import { amendmentsTextsPath, getAmendmentsApprovalMethodChangeBullet } from '~/business-logic/amendmentsLogic';
import { useLocaleKeys } from '~/i18n';
import { approvalMethodNoticePeriodModel, relationshipModel } from '~/models';
import AmendmentChangesInAgreementView from './AmendmentChangesInAgreementView';
import { SpecificTerm } from './CommonComponents';
export default function AgreementAmendmentsApprovalMethod(props) {
    const { relationship, testId } = props;
    const { t: amendmentsTexts } = useLocaleKeys(amendmentsTextsPath);
    const { t: viewTexts } = useLocaleKeys('pages.agreementMinisite.agreementView');
    const updated = relationshipModel.updatedAmendmentsApprovalMethod(relationship);
    const actual = relationshipModel.actualAmendmentsApprovalMethod(relationship);
    const isAutoApproval = approvalMethodNoticePeriodModel.isAutoApproval(actual);
    const changeBullet = updated ? getAmendmentsApprovalMethodChangeBullet({
        originalApprovalMethod: relationship.amendmentsApprovalMethod,
        newApprovalMethod: updated.value(),
        texts: amendmentsTexts
    }) : null;
    return isAutoApproval || updated ? /*#__PURE__*/ _jsx(SpecificTerm, {
        field: viewTexts.amendments(),
        value: approvalMethodNoticePeriodModel.amendmentsDescription(actual),
        testId: testId + 'notice-period',
        changes: changeBullet && /*#__PURE__*/ _jsx(AmendmentChangesInAgreementView, {
            disableBorderRadius: true,
            items: [
                changeBullet
            ],
            autoApprovalDate: relationshipModel.updatedAmendmentsApprovalMethodAutoApprovalDate(relationship),
            testId: testId + 'notice-changes'
        })
    }) : null;
}
